/**
 * Explicit inventory of implemented council detail pages.
 *
 * This deliberately does not derive from entity coverage: a verified entity
 * and a public report route are independent facts.
 */
export const COUNCIL_REPORT_PAGE_SLUGS = Object.freeze([
    'barking-and-dagenham',
    'barnet',
    'barnsley',
    'bath-and-north-east-somerset',
    'bedford',
    'bexley',
    'birmingham',
    'blackburn-with-darwen',
    'blackpool',
    'bolton',
    'bournemouth-christchurch-and-poole',
    'bracknell-forest',
    'bradford',
    'brent',
    'brighton-and-hove',
    'bristol',
    'bromley',
    'buckinghamshire',
    'bury',
    'calderdale',
    'cambridgeshire',
    'camden',
    'central-bedfordshire',
    'cheshire-east',
    'cheshire-west-and-chester',
    'city-of-london',
    'york',
    'cornwall',
    'coventry',
    'croydon',
    'cumberland',
    'darlington',
    'derby',
    'derbyshire',
    'devon',
    'doncaster',
    'dorset',
    'dudley',
    'durham',
    'ealing',
    'east-riding-of-yorkshire',
    'east-sussex',
    'enfield',
    'essex',
    'gateshead',
    'gloucestershire',
    'greenwich',
    'hackney',
    'halton',
    'hammersmith-and-fulham',
    'hampshire',
    'haringey',
    'harrow',
    'hartlepool',
    'havering',
    'herefordshire',
    'hertfordshire',
    'hillingdon',
    'hounslow',
    'isle-of-wight',
    'isles-of-scilly',
    'islington',
    'kensington-and-chelsea',
    'kent',
    'hull',
    'kingston-upon-thames',
    'kirklees',
    'knowsley',
    'lambeth',
    'lancashire',
    'leeds',
    'leicester',
    'leicestershire',
    'lewisham',
    'lincolnshire',
    'liverpool',
    'luton',
    'manchester',
    'medway',
    'merton',
    'middlesbrough',
    'milton-keynes',
    'newcastle',
    'newham',
    'norfolk',
    'north-east-lincolnshire',
    'north-lincolnshire',
    'north-northamptonshire',
    'north-somerset',
    'north-tyneside',
    'north-yorkshire',
    'northumberland',
    'nottingham',
    'nottinghamshire',
    'oldham',
    'oxfordshire',
    'peterborough',
    'plymouth',
    'portsmouth',
    'reading',
    'redbridge',
    'redcar-and-cleveland',
    'richmond-upon-thames',
    'rochdale',
    'rotherham',
    'rutland',
    'salford',
    'sandwell',
    'sefton',
    'sheffield',
    'shropshire',
    'slough',
    'solihull',
    'somerset',
    'south-gloucestershire',
    'south-tyneside',
    'southampton',
    'southend-on-sea',
    'southwark',
    'st-helens',
    'staffordshire',
    'stockport',
    'stockton-on-tees',
    'stoke-on-trent',
    'suffolk',
    'sunderland',
    'surrey',
    'sutton',
    'swindon',
    'tameside',
    'telford-and-wrekin',
    'thurrock',
    'torbay',
    'tower-hamlets',
    'trafford',
    'wakefield',
    'walsall',
    'waltham-forest',
    'wandsworth',
    'warrington',
    'warwickshire',
    'west-berkshire',
    'west-northamptonshire',
    'west-sussex',
    'westminster',
    'westmorland-and-furness',
    'wigan',
    'wiltshire',
    'windsor-and-maidenhead',
    'wirral',
    'wokingham',
    'wolverhampton',
    'worcestershire',
]);
export const COUNCIL_REPORT_PAGES = Object.freeze(COUNCIL_REPORT_PAGE_SLUGS.map((slug) => ({
    slug,
    reportUrl: `/councils/${slug}`,
})));
export const COUNCIL_REPORT_PAGE_BY_SLUG = new Map(COUNCIL_REPORT_PAGES.map((page) => [page.slug, page]));
